import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getDatabase, ref, onChildAdded, get, set } from 'firebase/database';

@Injectable({
  providedIn: 'root'
})
export class ChatStateService {
  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  private trackedChats: Set<string> = new Set();

  constructor() {
    this.trackAllUnreadMessages();
  }

  setUnreadCount(count: number) {
    this.unreadCountSubject.next(count);
  }

  private async trackAllUnreadMessages() {
    const db = getDatabase();
    const dbRef = ref(db, 'assistance_chat_active');

    onChildAdded(dbRef, async snapshot => {
      const chat = snapshot.val();
      const caseId = chat.caseNumber || chat.id;

      if (!this.trackedChats.has(caseId)) {
        this.trackedChats.add(caseId);

        // Cargar mensajes existentes no leídos
        await this.countUnreadForCase(caseId);

        // Escuchar nuevos mensajes no leídos
        this.listenToUnreadInCase(caseId);
      }
    });
  }

  private async countUnreadForCase(caseId: string) {
    const db = getDatabase();
    const messagesRef = ref(db, `assistance_chat/${caseId}`);
    const snapshot = await get(messagesRef);

    if (snapshot.exists()) {
      let count = 0;
      snapshot.forEach(child => {
        const message = child.val();
        if (message.from === 'user' && message.seen === false) {
          count++;
        }
      });

      if (count > 0) {
        const prev = this.unreadCountSubject.getValue();
        this.unreadCountSubject.next(prev + count);
      }
    }
  }

  private listenToUnreadInCase(caseId: string) {
      const db = getDatabase();
      const messagesRef = ref(db, `assistance_chat/${caseId}`);
    
      get(messagesRef).then(snapshot => {
        let unread = 0;
        snapshot.forEach(child => {
          const msg = child.val();
          if (msg.from === 'user' && msg.seen === false) {
            unread++;
          }
        });
        if (unread > 0) {
          this.unreadCountSubject.next(this.unreadCountSubject.getValue() + unread);
        }
      });
      onChildAdded(messagesRef, (snapshot) => {
            const message = snapshot.val();
            
            if (message.from === 'user' && message.seen === false) {
              this.unreadCountSubject.next(this.unreadCountSubject.getValue() + 1);
            }
          });
          
    }
    

  public async markMessagesAsRead(caseId: string) {
    const db = getDatabase();
    const messagesRef = ref(db, `assistance_chat/${caseId}`);
    const snapshot = await get(messagesRef);

    if (snapshot.exists()) {
      snapshot.forEach(child => {
        const key = child.key;
        const message = child.val();

        if (message.from === 'user' && message.seen === false) {
          const msgRef = ref(db, `assistance_chat/${caseId}/${key}`);
          message.seen = true;
          set(msgRef, message);
          const prev = this.unreadCountSubject.getValue();
          this.unreadCountSubject.next(Math.max(prev - 1, 0)); 
        }
      });
    }
  }

  getUnreadCount(): number {
      return this.unreadCountSubject.getValue();
    }
    
}
